import React from "react";
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUIInputLabel from "@mui/material/InputLabel";
import { extractFormFieldError, getClassName } from "@sscs/utils";
import { Controller, useFormContext, } from "react-hook-form";
import TextField from "../../TextField/TextField";
import { useControlSize } from "../formDense";
import formLayout from "../formLayout.module.scss";
import { useRegisterRequiredField } from "../requiredFields";
import styles from "./autocomplete.module.scss";
function Autocomplete({ size, variant = "outlined", isRequired = false, isReadOnly = false, isFullWidth = true, isClearable = true, freeSolo = false, multiline = false, InputProps = {}, ...props }) {
    const { control } = useFormContext();
    const resolvedSize = useControlSize(size);
    useRegisterRequiredField(isRequired);
    const { errorMessage, hasError } = extractFormFieldError(props.name, props === null || props === void 0 ? void 0 : props.errors);
    const cls = getClassName(styles.root, formLayout.field, props.className, {
        [styles.isFullWidth]: isFullWidth,
        [styles.isMultiline]: multiline,
    });
    return (React.createElement(Controller, { name: props.name, control: control, render: ({ field: { ref, ...field } }) => {
            var _a;
            return (React.createElement("div", { className: cls },
                props.label && (React.createElement(MUIInputLabel, { htmlFor: props.id || props.name, error: hasError, required: isRequired, disabled: props.isDisabled }, props.label)),
                React.createElement(MUIAutocomplete, { ...(props.onInputChange
                        ? { onInputChange: props.onInputChange }
                        : {}), ...(props.inputValue !== undefined
                        ? { inputValue: props.inputValue }
                        : {}), ...field, id: props.id, fullWidth: isFullWidth, value: (_a = field.value) !== null && _a !== void 0 ? _a : null, onChange: (_e, data) => {
                        var _a;
                        field.onChange(data);
                        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, data);
                    }, onBlur: () => {
                        var _a;
                        field.onBlur();
                        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
                    }, onKeyDown: props.onKeyDown, freeSolo: freeSolo, options: props.options, renderOption: props.renderOption, renderTags: props.renderTags, filterOptions: props.filterOptions, size: resolvedSize, disabled: props.isDisabled, readOnly: isReadOnly, getOptionLabel: props.getOptionLabel, multiple: props.multiSelect, disablePortal: props.disablePortal, disableClearable: !isClearable || multiline, renderInput: (params) => (React.createElement(TextField, { ...params, name: field.name, inputRef: ref, variant: variant, size: resolvedSize, placeholder: props.placeholder, fullWidth: isFullWidth, error: hasError, helperText: errorMessage || props.helperText, disabled: props.isDisabled, required: props.multiSelect ? undefined : isRequired, multiline: multiline, rows: multiline ? 5 : undefined, slotProps: {
                            input: {
                                ...params.InputProps,
                                ...InputProps,
                            },
                            htmlInput: {
                                ...params.inputProps,
                                ...props.htmlInput,
                            },
                        } })), slotProps: {
                        chip: {
                            classes: props.chipClasses,
                        },
                    } })));
        } }));
}
export default Autocomplete;
//# sourceMappingURL=Autocomplete.js.map